import PropTypes from 'prop-types';

import {
  SIDE_PANEL_CATEGORY_ACC,
  SIDE_PANEL_CATEGORY_ENT,
  SIDE_PANEL_CATEGORY_RLE,
  SIDE_PANEL_CATEGORY_USR,
} from './constant';

const DATA = {
  type: PropTypes.oneOf([
    SIDE_PANEL_CATEGORY_USR,
    SIDE_PANEL_CATEGORY_ACC,
    SIDE_PANEL_CATEGORY_RLE,
    SIDE_PANEL_CATEGORY_ENT,
  ]),
  Ent_PRIVILIGED: PropTypes.string,
  Ent_ENTITLEMENT_GLOSSARY: PropTypes.string,
  COMMENTS: PropTypes.string,
  CERT_USERKEY: PropTypes.string,
  CERT_ACCOUNTKEY: PropTypes.string,
  CERTIFIED: PropTypes.number,
  enableAction: PropTypes.arrayOf(PropTypes.string),
  availableAction: PropTypes.shape({
    approve: PropTypes.string,
    conditionalCertifiy: PropTypes.string,
    consult: PropTypes.string,
    reassign: PropTypes.string,
    reject: PropTypes.string,
  }),
  ENTITLEMENTTYPE: PropTypes.string,
  id: PropTypes.string,
  ENTITLEMENT_VALUE: PropTypes.string,
  CERT_ROLEKEY: PropTypes.string,
  LASTCERTIFIED: PropTypes.string,
  isConsulted: PropTypes.bool,
  AUDIT_TRAIL: PropTypes.string,
  ACCESSTHROUGH: PropTypes.string,
  Ent_DESCRIPTION: PropTypes.string,
  Ent_DISPLAYNAME: PropTypes.string,
  LASTCERTIFIEDUSER: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  LASTCERTIFIEDCAMPAIGNNAME: PropTypes.string,
  ENDPOINT: PropTypes.string,
  CERT_ENTITLEMENT_VALUEKEY: PropTypes.string,
  tracker: PropTypes.shape({
    actions: PropTypes.objectOf(
      PropTypes.shape({
        isSelected: PropTypes.bool,
        isLoading: PropTypes.bool,
      })
    ),
    id: PropTypes.string,
    isChecked: PropTypes.bool,
    isConnected: PropTypes.bool,
    level: PropTypes.number,
  }),
};

export default DATA;
